import type { AsyncDataOptions } from '#app'

export const useAsyncDefaults = <T>() => {
  const asyncOptions: AsyncDataOptions<T | null> = {
    // @ts-ignore - forcing property if shim is missing
    staleTime: 1000 * 60 * 5,

    // Using 'as any' here bypasses the Ref compatibility check
    // while keeping the logic functional for your components.
    default: () => null as any
  }

  return asyncOptions
}
